

























































import { Component, Vue } from 'vue-property-decorator'
import { ModuleSuggestionRequest } from '@/types/module-suggestion'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'

@Component({})
export default class NewModuleForm extends Vue {
    placeholders = {
        description: `La demande de création d'un nouvel atelier sera directement traitée par l'administrateur de l'opération.
Merci de bien vouloir nous décrire précisément vos attentes pour cet atelier :
- Nom de l'atelier
- Objectifs
- Nom du groupe concerné (le cas échéant)
- Questions et réponses attendues`,
    }
    errors = {
        title: false,
        description: false,
    }
    title: string = ''
    description: string = ''

    isValid() {
        this.errors = {
            title: false,
            description: false,
        }

        if (this.title.trim().length < 5) {
            this.errors.title = true
            return false
        }
        if (this.description.trim().length < 5) {
            this.errors.description = true
            return false
        }

        return true
    }

    async onSubmit() {
        if (!this.isValid()) {
            return
        }

        const req: ModuleSuggestionRequest = {
            title: this.title,
            description: this.description,
        }

        const apiService = new ApiService()
        try {
            const resp = await apiService.postModuleSuggestion(req)
            const data = resp.data
            this.$emit('alert', {
                type: 'success',
                message: data.message,
                duration: 5000,
            })

            const u = UserModule.userInfos
            const fullName = `${u.firstname} ${u.lastname}`.trim()
            apiService.postAdminNotification({
                type: 'suggestion',
                message: `${fullName} a soumis une suggestion d'atelier : « ${this.title} ».`.substring(0, 255),
                context: { user_id: u.id },
            }).catch(() => { /* silent */ })

            this.reset()
        } catch (e) {
            this.$emit('alert', {
                type: 'danger',
                message: `Impossible d'envoyer votre suggestion`,
            })
        }
    }

    reset() {
        this.errors = {
            title: false,
            description: false,
        }

        this.title = ''
        this.description = ''
    }
}
